import { Component, OnInit, Input } from '@angular/core';
import { PageItem } from '../page';
import { PageService } from '../page.service';



@Component({
  selector: 'app-menu-childs',
  templateUrl: './menu-childs.component.html',
  styleUrls: ['./menu-childs.component.css']
})
export class MenuChildsComponent implements OnInit {

  @Input() parent_id: string;
  @Input() parent_link: string;
  @Input() parent_title: string;
  childs : PageItem[] = [];
  plink:string;

  constructor(private pageService : PageService) { }

  ngOnInit() {
    this.getChilds();
  }

  getChilds(id = this.parent_id) {
    this.pageService.getChilds(id)
      .subscribe(data => {
        this.childs = data;
        this.plink = '';
        // data.forEach( (child)=> {
        //   if (child.hasChild) { this.pageService.getChilds(child.id); }
        // })
      });
  }

}
